import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx";
import { useTranslation } from 'react-i18next';

const TenantInvoiceReport = () => {
    const { t } = useTranslation(['reports', 'common']);
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        property: { label: "All", value: "All" },
        unitNo: "",
        tenant: "",
        from: "",
        to: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();

        const fromDate = new Date(today.getFullYear(), 0, 1);
        const toDate = new Date(today.getFullYear(), 11, 31);

        setFormData((prev) => ({
            ...prev,
            from: formatDate(fromDate),
            to: formatDate(toDate),
        }));
    }, []);


    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const dateFormatter = (params) => {
        if (!params.value) return '';
        const date = moment(params.value);
        return date.isValid() ? date.format('DD-MMM-YYYY') : '';
    };

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRAgreeSearchCustomers,');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
            setTanentList(res?.data?.dropdowns?.LRAgreeSearchCustomers || []);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("leaseInvoiceReportRequest.FromDate", formData?.from || updatedValue);
            params.append("leaseInvoiceReportRequest.ToDate", formData?.to || todate);
            params.append("leaseInvoiceReportRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("leaseInvoiceReportRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseInvoiceReportRequest.CustomerNo", formData?.tenant?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_TENANT_INVOICE", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            setLoading(false);
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("leaseInvoiceReportRequest.FromDate", formData?.from || updatedValue);
            params.append("leaseInvoiceReportRequest.ToDate", formData?.to || todate);
            params.append("leaseInvoiceReportRequest.PropertyNo", formData?.property?.value?.value || "All");
            params.append("leaseInvoiceReportRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseInvoiceReportRequest.CustomerNo", formData?.tenant?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_TENANT_INVOICE", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false);
        }
    }
    const columnDefs = [
        { headerName: t('reports:tenantInvoice.columns.invoiceNo'), field: "invoiceNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130, pinned: "left" },
        {
            headerName: t('reports:tenantInvoice.columns.postingDate'), field: "postingDate", filter: true, floatingFilter: true, suppressMovable: true, width: 130,

            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: t('reports:tenantInvoice.columns.customerType'), field: "customerType", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: t('reports:tenantInvoice.columns.customerACNo'), field: "customerACNo", filter: true, floatingFilter: true, suppressMovable: true, width: 150 },
        { headerName: t('reports:tenantInvoice.columns.customerName'), field: "customerName", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: t('reports:tenantInvoice.columns.propertyNo'), field: "propertyNo", filter: true, floatingFilter: true, suppressMovable: true, width: 130 },
        { headerName: t('reports:tenantInvoice.columns.propertyName'), field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 200 },
        { headerName: t('reports:tenantInvoice.columns.unitNo'), field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: t('reports:tenantInvoice.columns.paymentType'), field: "paymentType", filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: t('reports:tenantInvoice.columns.tax'), field: "tax", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: t('reports:tenantInvoice.columns.amount'), field: "amount", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: t('reports:tenantInvoice.columns.vat'), field: "vat", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: t('reports:tenantInvoice.columns.total'), field: "total", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
    ]
    const handleClearFilters = () => {
        setUnitList([])
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today.getFullYear(), 0, 1);
        const toDate = new Date(today.getFullYear(), 11, 31);
        setFormData({
            property: { label: "All", value: "All" },
            unitNo: "",
            tenant: "",
            from: formatDate(fromDate),
            to: formatDate(toDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const loadTenantOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "Invoice No", dataKey: "invoiceNo" },
        { header: "Posting Date", dataKey: "postingDate" },
        { header: "Customer A/C No", dataKey: "customerACNo" },
        { header: "Customer Name", dataKey: "customerName" },
        { header: "Property Name", dataKey: "propertyName" },
        { header: "Unit No", dataKey: "unitNo" },
        { header: "Payment Type", dataKey: "paymentType" },
        { header: "Tax", dataKey: "tax" },
        { header: "Amount", dataKey: "amount" },
        { header: "VAT", dataKey: "vat" },
        { header: "Total", dataKey: "total" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153);
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Tenant Invoice Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated on: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("TenantInvoiceReport.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const excelData = exportData.map(item => {
            const row = {};
            exportColumns.forEach(col => {
                row[col.header] = normalizeValue(item[col.dataKey]);
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tenant Invoice");
        XLSX.writeFile(workbook, "Tenant_Invoice_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">{t('common:searchParameters')}</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:property')} </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">{t('common:unitNo')} </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex" >
                                <label htmlFor="validationCustom18" className="form-label">{t('common:tenant')}</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        control: base => ({ ...base, fontSize: "12px" }),
                                        singleValue: base => ({ ...base, fontSize: "12px" }),
                                        input: base => ({ ...base, fontSize: "12px" }),
                                        placeholder: base => ({ ...base, fontSize: "12px" }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            fontSize: "12px",
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenant}
                                    loadOptions={loadTenantOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenant", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-end mt-3" style={{ maxWidth: '1200px', margin: 'auto', gap: '20px' }}>
                            <div className="d-flex flex-wrap" style={{ gap: '20px' }}>
                                <div className="d-flex">
                                    <label className="form-label">{t('common:from')}</label>
                                    <DatePicker
                                        selected={formData.from}
                                        onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label className="form-label w-0">{t('common:to')}</label>
                                    <DatePicker
                                        selected={formData.to}
                                        onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems(1)}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">{t('common:search')}</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">{t('common:reset')}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>{t('common:loading')}</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">{t('reports:tenantInvoice.title')}</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                {t('reports:exportAsPdf')}
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                {t('reports:exportAsExcel')}
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default TenantInvoiceReport;
